import { render, staticRenderFns } from "./myuser-card.vue?vue&type=template&id=4068b650&scoped=true"
import script from "./myuser-card.vue?vue&type=script&lang=js"
export * from "./myuser-card.vue?vue&type=script&lang=js"
import style0 from "./myuser-card.vue?vue&type=style&index=0&id=4068b650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068b650",
  null
  
)

export default component.exports